import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { ShipmentConfirmQCResult } from '../../core/api/lab.types';

export const shipmentConfirmQCHasErrorSelector = (state: RootState): any =>
  state.shipmentConfirmQC.errors && state.shipmentConfirmQC.errors
    ? { hasError: true, message: state.shipmentConfirmQC.errors[0].message }
    : { hasError: false };

export const shipmentConfirmQCIsBusySelector = (state: RootState): boolean =>
  state.shipmentConfirmQC.status === StoreStatus.BUSY;

export const shipmentConfirmQCResponseSelector = (state: RootState): ShipmentConfirmQCResult | null =>
  state.shipmentConfirmQC.response || null;
